import React, { ChangeEvent, FC } from 'react';

import { CmBox, CmFlex, CmFormLabel } from '@/components/uiParts';
import { DeliveryFormInput } from '@/pages/camel-order/delivery/components/Form/DeliveryFormInput';
import { camelOrderDeliveryForm } from '@/pages/camel-order/delivery/service';
import { DeliveryFormError } from '@/pages/camel-order/delivery/validate';

type Props = {
  error: DeliveryFormError;
  base_delivery_fee: string;
  base_delivery_fee_distance: string;
  additional_distance_fee: string;
  additional_distance: string;
  handleChangeBaseDeliveryFee: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChangeBaseDeliveryFeeDistance: (
    e: ChangeEvent<HTMLInputElement>
  ) => void;
  handleChangeAdditionalDistanceFee: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChangeAdditionalDistance: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const BaseDeliveryFeeAndAdditionalDistanceFeeForm: FC<Props> = ({
  error,
  base_delivery_fee,
  base_delivery_fee_distance,
  additional_distance_fee,
  additional_distance,
  handleChangeBaseDeliveryFee,
  handleChangeBaseDeliveryFeeDistance,
  handleChangeAdditionalDistanceFee,
  handleChangeAdditionalDistance,
}) => {
  const { baseDeliveryFee, additionalDistanceFee } = camelOrderDeliveryForm;
  return (
    <>
      <CmFlex alignItems="flex-end">
        <DeliveryFormInput
          {...{
            error: error.baseDeliveryFee,
            id: baseDeliveryFee.key,
            handleChangeDeliveryFormInput: handleChangeBaseDeliveryFee,
            value: base_delivery_fee,
            suffix: '円',
            label: (
              <CmFormLabel htmlFor={baseDeliveryFee.key}>
                {baseDeliveryFee.label}
              </CmFormLabel>
            ),
            placeholder: '500',
          }}
        />

        <CmBox ml="20px">
          <DeliveryFormInput
            {...{
              error: error.baseDeliveryFeeDistance,
              handleChangeDeliveryFormInput:
                handleChangeBaseDeliveryFeeDistance,
              value: base_delivery_fee_distance,
              suffix: 'km',
              placeholder: '5',
            }}
          />
        </CmBox>
      </CmFlex>
      <CmFlex alignItems="flex-end" mt="10px">
        <DeliveryFormInput
          {...{
            error: error.additionalDistanceFee,
            id: additionalDistanceFee.key,
            handleChangeDeliveryFormInput: handleChangeAdditionalDistanceFee,
            value: additional_distance_fee,
            suffix: '円',
            placeholder: '100',
            label: (
              <CmFormLabel htmlFor={additionalDistanceFee.key}>
                {additionalDistanceFee.label}
              </CmFormLabel>
            ),
          }}
        />
        <CmBox ml="20px">
          <DeliveryFormInput
            {...{
              error: error.additionalDistance,
              handleChangeDeliveryFormInput: handleChangeAdditionalDistance,
              value: additional_distance,
              suffix: 'km',
              placeholder: '0.5',
            }}
          />
        </CmBox>
      </CmFlex>
    </>
  );
};
